<template>
  <div class="p-4">
    <h1 class="text-xl font-bold mb-4">Browser Details</h1>
    <table class="table-auto w-full border-collapse border border-gray-400">
      <tbody>
        <tr class="odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800">
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">Browser</td>
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">{{ browserDetails.browser.name }} {{ browserDetails.browser.version }}</td>
        </tr>
        <tr class="odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800">
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">Operating System</td>
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">{{ browserDetails.os.name }} {{ browserDetails.os.version }}</td>
        </tr>
        <tr class="odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800">
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">Device</td>
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">{{ browserDetails.device.model }} {{ browserDetails.device.type }} {{ browserDetails.device.vendor }}</td>
        </tr>
        <!-- <tr>
          <td class="border border-gray-300 p-2">CPU Architecture</td>
          <td class="border border-gray-300 p-2">{{ browserDetails.cpu.architecture }}</td>
        </tr> -->
        <tr class="odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800">
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">User Agent</td>
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">{{ browserDetails.ua }}</td>
        </tr>

        <tr class="odd:bg-gray-50 even:bg-white dark:odd:bg-slate-850 dark:even:bg-slate-800">
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">Screen Resolution</td>
          <td class="border border-gray-300 p-2 text-gray-900 dark:text-gray-100">{{ screenResolution }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import UAParser from 'ua-parser-js';

export default defineComponent({
  name: 'BrowserDetails',
  setup() {
    const parser = new UAParser();
    const browserDetails = ref(parser.getResult());

    return { browserDetails, screenResolution: `${screen.width} x ${screen.height}` };
  }
});
</script>

<style scoped>
/* Tailwind utility classes handle most styling */
</style>
